export type StaffPanelBasePath = "/admin" | "/support";

/** True for the isolated staff consoles (`/admin`, `/support`). */
export function isStaffPanelPath(pathname: string): boolean {
	return (
		pathname === "/admin" ||
		pathname.startsWith("/admin/") ||
		pathname === "/support" ||
		pathname.startsWith("/support/")
	);
}

/** Admin paths that have a support-panel equivalent (same page, different prefix). */
const ADMIN_TO_SUPPORT_SEGMENTS = [
	"/users",
	"/activities",
	"/dunning",
	"/billing-issues",
	"/cancellations",
	"/partner-access",
	"/newsletter",
] as const;

export function isSupportPanelPath(pathname: string): boolean {
	return pathname === "/support" || pathname.startsWith("/support/");
}

/** Map `/admin/...` to `/support/...` when a support route exists; otherwise default landing. */
export function mapAdminPathToSupport(pathname: string): string {
	if (pathname === "/admin" || pathname === "/admin/") {
		return "/support/users";
	}

	for (const segment of ADMIN_TO_SUPPORT_SEGMENTS) {
		if (pathname === `/admin${segment}` || pathname.startsWith(`/admin${segment}/`)) {
			return pathname.replace(/^\/admin/, "/support");
		}
	}

	return "/support/users";
}

export function joinStaffPanelPath(basePath: StaffPanelBasePath, subpath: string): string {
	const normalized = subpath.startsWith("/") ? subpath : `/${subpath}`;
	return `${basePath}${normalized}`;
}
